<template>
  <div class="detail" v-loading="loading">
    <div class="detail-first">
      <div class="detail-first-block">
        <div class="first-block-list" v-for="(item, index) in 6" :key="index">
          <div class="first-block-list-title">
            {{
              index == 0
                ? '用户id'
                : index == 1
                ? '用户名称'
                : index == 2
                ? '用户电话'
                : index == 3
                ? '奖品类型'
                : index == 4
                ? '奖品名称'
                : index == 5
                ? '中奖时间'
                : ''
            }}
          </div>
          <div class="first-block-list-input" v-if="index != 5">
            <el-input
              v-if="index == 0"
              placeholder="请输入用户id"
              v-model="userId"
              clearable
            >
            </el-input>
            <el-input
              v-if="index == 1"
              placeholder="请输入用户名称"
              v-model="userName"
              clearable
            >
            </el-input>
            <el-input
              v-if="index == 2"
              placeholder="请输入用户电话"
              v-model="userPhone"
              clearable
            >
            </el-input>
            <el-input
              v-if="index == 4"
              placeholder="请输入奖品名称"
              v-model="prizeName"
              clearable
            >
            </el-input>

            <el-select
              v-if="index == 3"
              v-model="prizeType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in prizeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="first-block-list-picker" v-else>
            <el-date-picker
              v-model="prizeTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator=""
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="detail-first-button">
        <div class="detail-first-button-left" @click="detailInquire">查询</div>
        <div class="detail-first-button-right" @click="detailReset">重置</div>
      </div>
    </div>

    <div class="detail-second">
      <div class="detail-second-top">
        <div class="second-top-left">查询结果</div>
        <div class="second-top-right">
          <div class="second-top-right-refresh" @click="refresh">刷新</div>
          <div class="second-top-right-derive" @click="export2Excel">
            <img
              class="derive-img"
              src="../../assets/common/common-derive.png"
            />
            <div class="derive-title">导出明细</div>
          </div>
        </div>
      </div>

      <div class="detail-second-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border=""
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="userId" label="用户ID"> </el-table-column>
          <el-table-column prop="userPhone" label="用户手机号" width="196">
          </el-table-column>
          <el-table-column prop="nickname" label="用户名称" width="220">
          </el-table-column>
          <el-table-column prop="lunck_name" label="奖品名称" width="384">
          </el-table-column>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              {{
                scope.row.lunck_type == '0'
                  ? '谢谢惠顾'
                  : scope.row.lunck_type == '1'
                  ? '积分'
                  : scope.row.lunck_type == '2'
                  ? '商品'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="lunck_cost" label="成本(元)">
          </el-table-column>
          <el-table-column prop="createTime" label="中奖时间" width="296">
          </el-table-column>
        </el-table>
      </div>

      <div class="detail-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getluckprizeDetail } from '../../api/activities'
export default {
  data() {
    return {
      // 用户id
      userId: '',
      // 用户名称
      userName: '',
      // 用户电话
      userPhone: '',
      // 奖品类型
      prizeType: '',
      prizeList: [
        {
          value: '0',
          label: '谢谢惠顾',
        },
        {
          value: '1',
          label: '积分',
        },
        {
          value: '2',
          label: '商品',
        },
      ],
      // 奖品名称
      prizeName: '',
      // 中奖时间区间
      prizeTime: [],
      // 用户时间输入框的时候起始值
      prizeTimeA: '',
      // 用户时间输入框的时候结尾值
      prizeTimeB: '',
      // 表格区域
      tableData: [],
      // 存储表格选中的值
      multipleSelection: [],
      // 页码
      page: 1,
      // 条数
      limit: 10,
      // 总条数
      totalNum: 0,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      activeiesFunShow: false,
    }
  },
  created() {
    // 获取大轮盘中奖明细接口数据
    this.loading = true
    this.getluckprize()

    setTimeout(() => {
        this.activeiesFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取大轮盘中奖明细接口数据
    getluckprize() {
      let params = {
        userId: this.userId, // 用户id
        userPhone: this.userPhone, // 用户手机号
        nickname: this.userName, // 用户名称
        lunck_type: this.prizeType, // 奖品类型 0谢谢惠顾 1积分 2商品
        lunck_name: this.prizeName, // 奖品名字
        createStartTime: this.prizeTimeA, // 中将开始时间
        createEndTime: this.prizeTimeB, // 中将结束时间
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getluckprizeDetail(params).then((res) => {
        console.log('获取数据', res)
        if (res.resultStatus == true) {
          // 表格数据
          this.tableData = res.resultData.luckDetailList
          // 总条数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 第一区域点击查询
    detailInquire() {
      console.log('时间区域', this.prizeTime)
      this.loading = true

      if (this.prizeTime != null) {
        this.prizeTimeA = this.prizeTime[0]
        this.prizeTimeB = this.prizeTime[1]
      } else {
        this.prizeTimeA = ''
        this.prizeTimeB = ''
      }

      this.$nextTick(() => {
        this.getluckprize()
      })
    },
    // 第一区域点击重置
    detailReset() {
      this.userId = '' // 用户id
      this.userPhone = '' // 用户手机号
      this.userName = '' // 用户名称
      this.prizeType = '' // 奖品类型 0谢谢惠顾 1积分 2商品
      this.prizeName = '' // 奖品名字
      this.prizeTimeA = '' // 中将开始时间
      this.prizeTimeB = '' // 中将结束时间
      this.prizeTime = []
      this.page = 1
      // 清空重选搜索
      this.getluckprize()
    },
    // 第二区域 刷新
    refresh() {
      this.loading = true

      this.$nextTick(() => {
        this.getluckprize()
      })
    },

    // 用户点击导出订单
    export2Excel() {
      if (this.activeiesFunShow == false) {
        return
      }

      this.loading = true

      let trochaidiskIds = ''

      if (this.multipleSelection.length == 0) {
        trochaidiskIds = this.userId
      } else {
        trochaidiskIds = this.multipleSelection
          .map((item) => {
            return item.id
          })
          .join(';')
      }
      let louckType =
        this.prizeType == '0'
          ? '谢谢惠顾'
          : this.prizeType == '1'
          ? '积分'
          : this.prizeType == '2'
          ? '商品'
          : ''

      let conversionTimeA =
        this.prizeTimeA == undefined ? '' : this.conversionTimeA
      let conversionTimeB =
        this.prizeTimeB == undefined ? '' : this.conversionTimeB

      /*---------------------*/

      let Url =
        'https://laravel-api-manager.xmw1688.com/v1/manager/luck/detail?excel=' +
        1 +
        '&ids=' +
        trochaidiskIds +
        '&userId' +
        this.userId +
        '&userPhone=' +
        this.userPhone +
        '&nickname=' +
        this.userName +
        '&lunck_type=' +
        louckType +
        '&lunck_name=' +
        this.prizeName +
        '&createStartTime=' +
        conversionTimeA +
        '&createEndTime=' +
        conversionTimeB +
        '&accessToken=' +
        localStorage.getItem('token')

      console.log('查询参数', Url)

      window.location.href = Url

      this.loading = false
    },

    // 表格区域点击选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getluckprize()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getluckprize()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.detail {
  .detail-first {
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 30px 24px;
    box-sizing: border-box;

    .detail-first-block {
      display: flex;
      align-items: center;

      .first-block-list {
        margin-right: 24px;
        .first-block-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 4px;
        }

        .first-block-list-input {
          width: 180px;
          height: 32px;
          background: #ffffff;
          border-radius: 5px;

          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }
        }

        .first-block-list-picker {
          width: 385px;
          /deep/ .el-input__inner {
            height: 32px;
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 100%;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-block-list:last-child {
        margin-right: 0;
      }
    }

    .detail-first-button {
      display: flex;
      margin-top: 27px;

      .detail-first-button-left,
      .detail-first-button-right {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }

      .detail-first-button-right {
        background: #f4f5f9;
        color: #999999;
        margin-left: 10px;
      }
    }
  }

  .detail-second {
    margin-top: 24px;
    background: #ffffff;
    padding: 0 24px;
    box-sizing: border-box;
    .detail-second-top {
      width: 100%;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .second-top-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }

      .second-top-right {
        display: flex;
        .second-top-right-refresh {
          width: 70px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(34, 34, 34, 0.4);
          text-align: center;
          line-height: 36px;
          cursor: pointer;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: bold;
        }

        .second-top-right-derive {
          display: flex;
          height: 36px;
          align-items: center;
          justify-content: center;
          width: 110px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          cursor: pointer;

          .derive-img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }

          .derive-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }

    .detail-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }
    }

    .detail-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>
